import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Helmet } from "react-helmet";
import { Link, Redirect, Prompt } from 'react-router-dom';
import './Events.css';

import { ChangePictureIcon, LiveGames, PostItem, EmptyState, LoadingState, GlobalTMFeeds, GlobalTMForm, LeagueSplitView, ConfirmModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PublicityPicker } from '.././components/Common';
import { EventViewCreateForm1, EventViewSplitPane, EventGroupChatCreate, LocationPicker } from '.././components/Event';
import Avatar from '.././components/Avatar';
import GroupEvents, { EventCalenderView } from '.././components/GroupEvents';
import GroupMembers from '.././components/GroupMembers';
import Photos from '.././components/Photos';
import Videos from '.././components/Videos';
import InternalNoticeCenter from '.././components/InternalNoticeCenter';
import { CreateNormalEvent } from './Home';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;
const { google } = window;

export default class Events extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            search: [],
            recent: [],
            popular: [],
            today: [],
            birthdays: {
                past: [],
                upcoming: [],
                today: []
            },
            isLoading: true,
            activeTab: 'trend',
            tabs: [
                { val: "trend", key: "Events", notices: [] },
                { val: "calendar", key: "Calendar", notices: [] },
                { val: "birthdays", key: "Birthdays", notices: [] },
                { val: "past", key: "Past", notices: [] }
            ],
            activeTrend: "today",
            trends: [
                { val: "today", key: "Today", notices: [] },
                { val: "popular", key: "Popular", notices: [] },
                { val: "recent", key: "Recent", notices: [] }
            ],
            isAddingEvent: false
        }
    }

    componentDidMount() {
        var params = FakeData.getQueries(this.props.location.search);
        this.setState({ activeTab: (params.sInit) ? params.sInit : "trend" });
        //console.log(params)
        FakeData.mountState("events", true)
        if (params.sInit === "find") {
            this.findEvents(params.start, params.end)
        } else {
            this.getEvents()
        }

        this.getBatchEvents()
        this.getUpcomingBirthdays()
    }

    getDummy = (_num) => {
        const list = [];
        for (var index = 0; index < _num; index++) {
            list.push({ text: index })
        }

        return list;
    }

    getEvents = () => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            userToId: FakeData.getData("yoo").id,
            userToType: "F",
            teamIds: []
        }

        FakeData.post("/getEvents.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("events")) {
                    return
                }
                if (res.length === 0) {
                    //_that.getEvents();
                    return;
                }
                res.sort(function (a, b) {
                    return a.timestamp - b.timestamp
                })

                _that.setState({
                    events: res,
                    isLoading: false
                })

                if (res.length > 0) {
                    // return;
                }

                setTimeout((() => {
                    _that.getEvents()
                }), 10000)
            }),
            error: ((err) => {
                
            })
        })
    }

    findEvents = (start, end) => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            userToId: FakeData.getData("yoo").id,
            userToType: "F",
            start,
            end
        }

        //console.log(dataTo)
        FakeData.post("/findEvents.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("events")) {
                    return
                }

                res.data.sort(function (a, b) {
                    return a.timestamp - b.timestamp
                })

                _that.setState({
                    search: res.data,
                    isLoading: false
                })

                if (res.length > 0) {
                    // return;
                }

                setTimeout((() => {
                    //_that.findEvents()
                }), 10000)
            }),
            error: ((err) => {
                
            })
        })
    }

    getFriends = () => {
        const list = [];
        FakeData.listify(FakeData.getData("yoo").friends).forEach((item, i) => {
            list.push(item.id);
        })

        return list;
    }

    getBatchEvents = () => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            userToId: FakeData.getData("yoo").id,
            userToType: "F",
            teamIds: [],
            friends: this.getFriends()
        }

        FakeData.post("/getBatchEvents.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("events")) {
                    return
                }
                const { today, recent, popular } = res
                today.sort(function (a, b) {
                    return a.timestamp - b.timestamp
                })

                recent.sort(function (a, b) {
                    return a.timestamp - b.timestamp
                })

                popular.sort(function (a, b) {
                    return a.timestamp - b.timestamp
                })

                _that.setState({
                    today, popular, recent
                })

                setTimeout((() => {
                    _that.getBatchEvents()
                }), 10000)
            }),
            error: ((err) => {
                
            })
        })
    }

    getUpcomingBirthdays = () => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            userToId: FakeData.getData("yoo").id,
            userToType: "F",
            friends: this.getFriends()
        }

        FakeData.post("/getUpcomingBirthdays.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("events")) {
                    return
                }

                _that.setState({
                    birthdays: res
                })

                setTimeout((() => {
                    _that.getUpcomingBirthdays()
                }), 10000)
            }),
            error: ((err) => {
                
            })
        })
    }

    getFixedFilters = () => {
        return [
            { icon: "query_builder", text: "Today", click() { }, color: "#4F595C" },
            { icon: "watch_later", text: "Tomorrow", click() { }, color: "#44aacc" },
            { icon: "event", text: "This Week", click() { }, color: "#D21E41" },
            { icon: "date_range", text: "Choose Date", click() { }, color: "#C4C3BC" }
        ];
    }

    getEventMonths = (events) => {
        const list = [];
        FakeData.listify(events).forEach((item, i) => {
            if (!FakeData.inArray(item.month, list)) {
                list.push(item.month)
            }
        })

        return list;
    }

    getBirthMonths = (birthdays) => {
        const list = [];
        FakeData.listify(birthdays).forEach((item, i) => {
            if (!FakeData.inArray(item.birthday.month, list)) {
                list.push(item.birthday.month)
            }
        })

        return list;
    }

    getMonthEvents = (month, events) => {
        const list = FakeData.listify(events).filter((item, i) => {
            return item.month === month || item.e_month === month;
        })

        return list;
    }

    getMonthBirthdays = (month, birthdays) => {
        const list = FakeData.listify(birthdays).filter((item, i) => {
            return item.birthday.month === month;
        })

        return list;
    }

    goTo = (txt) => {
        if (txt === "this week") {
            var date = new Date();
            var start = (date.getMonth() + 1) + " " + date.getDate() + " " + date.getFullYear();

            var date1 = new Date();
            date1.setDate(date1.getDate() + 7);
            var end = (date1.getMonth() + 1) + " " + date1.getDate() + " " + date1.getFullYear();
            const url = "/events?sInit=find&start=" + start + "&end=" + end;
            window.location = url;
        } else {
            const url = "/events?sInit=find&start=" + txt + "&end=" + txt;
            window.location = url;
        }
    }

    render() {
        const { events, today, recent, popular, activeTab, tabs, activeTrend, trends, birthdays, isLoading, isAddingEvent } = this.state;
        const { } = this.props;
        return (
            <div className="events-page">
                <div className="events-page-left">
                    <div className="events-page-left-head">
                        <i className="material-icons">event</i>
                        <span>Events</span>
                    </div>
                    <div className="events-page-left-nav">
                        {
                            tabs.map((item, i) => {
                                return (
                                    <div key={i} className={activeTab === item.val ? "active" : ""} onClick={() => {
                                        this.setState((state, props) => { return { activeTab: item.val } })
                                        if (item.val !== "find" && events.length === 0) {
                                            this.getEvents()
                                            this.setState((state, props) => { return { isLoading: true } })
                                        }
                                    }}>
                                        {item.key}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <button className="events-page-left-btn" onClick={() => this.setState({ isAddingEvent: true })}>
                        <i className="material-icons">add</i>
                        <span>Create Event</span>
                    </button>
                </div>

                {isLoading &&
                    <div className="events-page-mid">
                        <FullPanel
                            title={"Please wait..."}
                            showFoot={false}
                            foot={"See All"}
                            onFootClick={() => {

                            }}>

                            <LoadingState isShown={isLoading} text={"Loading"} />

                        </FullPanel>
                    </div>
                }
                {activeTab === "trend" && !isLoading &&
                    <div className="events-page-mid">
                        <FullPanel
                            title={"Upcoming"}
                            showFoot={true}
                            foot={"See All"}
                            onFootClick={() => {

                            }}>
                            {
                                events.filter((item) => { return !item.isPast && !item.isToday }).map((item, i) => {
                                    return (
                                        <UpcomingEventItem event={item} key={i} />
                                    )
                                })
                            }
                            <EmptyState style={{ background: "#fff" }} isShown={(events.filter((item) => { return !item.isPast && !item.isToday }).length === 0) ? true : false} text="No events were found!" icon="event" />
                        </FullPanel>

                        <FullPanel
                            title={
                                <div className="gle-tabs">
                                    {
                                        trends.map((item, i) => {
                                            return (
                                                <div key={i} className={activeTrend === item.val ? "active" : ""} onClick={() => this.setState({ activeTrend: item.val })}>{item.key}</div>
                                            )
                                        })
                                    }
                                </div>
                            }
                            showFoot={false}
                            foot={""}
                            thisCss={{ marginTop: "1vw", width: "39vw" }}
                            titleCss={{ borderBottom: "none" }}
                            bodyCss={{ padding: "0px" }}
                            onFootClick={() => {

                            }}>
                            <EventSlider style={{ display: activeTrend === "today" ? "" : "none" }} events={today} />
                            <EventSlider style={{ display: activeTrend === "popular" ? "" : "none" }} events={popular} />
                            <EventSlider style={{ display: activeTrend === "recent" ? "" : "none" }} events={recent} />
                        </FullPanel>
                    </div>
                }

                {activeTab === "calendar" && !isLoading &&
                    <div className="events-page-mid" style={{ width: "59vw", background: "#fff" }}>
                        <EventCalenderView events={events} isAdmin={false} />
                    </div>
                }

                {activeTab === "birthdays" && !isLoading &&
                    <div className="events-page-mid">
                        <FullPanel
                            title={"Today"}
                            showFoot={false}
                            foot={""}
                            bodyCss={{ padding: "0px" }}
                            onFootClick={() => {

                            }}>
                            {
                                birthdays.today.map((item, i) => {
                                    return (
                                        <BirthdayWishForm isToday={true} key={i} birthday={item} userId={FakeData.getData("yoo").id} userType={"F"} />
                                    )
                                })
                            }
                            <EmptyState style={{ background: "#fff" }} isShown={(birthdays.today.length === 0) ? true : false} text="No birthdays were found!" icon="event" />
                        </FullPanel>

                        <FullPanel
                            title={"Recent Birthdays"}
                            showFoot={false}
                            foot={""}
                            thisCss={{ marginTop: "1vw" }}
                            bodyCss={{ padding: "0px" }}
                            onFootClick={() => {

                            }}>
                            <div className="events-page-past-list">
                                {
                                    this.getBirthMonths(birthdays.past.filter((item) => { return item.birthday.when === "Yesterday" })).map((item, i) => {
                                        return (
                                            <div key={item} className="events-page-past-item">
                                                <span>{item}</span>
                                                <div className="events-page-past-items">
                                                    {
                                                        this.getMonthBirthdays(item, birthdays.past.filter((item) => { return item.birthday.when === "Yesterday" })).map((_item, _i) => {
                                                            return (
                                                                <BirthdayWishForm isToday={false} key={_i} birthday={_item} userId={FakeData.getData("yoo").id} userType={"F"} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <EmptyState style={{ background: "#fff" }} isShown={(birthdays.past.filter((item) => { return item.birthday.when === "Yesterday" }).length === 0) ? true : false} text="No recent birthdays were found!" icon="event" />
                        </FullPanel>

                        <FullPanel
                            title={"Upcoming Birthdays"}
                            showFoot={false}
                            foot={""}
                            thisCss={{ marginTop: "1vw" }}
                            bodyCss={{ padding: "0px" }}
                            onFootClick={() => {

                            }}>
                            <div className="events-page-past-list">
                                {
                                    this.getBirthMonths(birthdays.upcoming).map((item, i) => {
                                        return (
                                            <div key={item} className="events-page-past-item">
                                                <span>{item}</span>
                                                <div className="events-page-past-items">
                                                    {
                                                        this.getMonthBirthdays(item, birthdays.upcoming).map((_item, _i) => {
                                                            return (
                                                                <div className="events-page-up-birth-items" key={_i}>
                                                                    <img src={_item.user.image} />
                                                                    <div>
                                                                        <a>{_item.user.name}</a>
                                                                        <span>Turning {_item.birthday.turning} years old</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <EmptyState style={{ background: "#fff" }} isShown={(birthdays.upcoming.length === 0) ? true : false} text="No upcoming birthdays were found!" icon="event" />
                        </FullPanel>
                    </div>
                }

                {activeTab === "past" && !isLoading &&
                    <div className="events-page-mid">
                        <FullPanel
                            title={"Past Events"}
                            showFoot={false}
                            foot={""}
                            bodyCss={{ padding: "0px" }}
                            onFootClick={() => {

                            }}>
                            <div className="events-page-past-list">
                                {
                                    this.getEventMonths(events.filter((item) => { return item.isPast })).map((item, i) => {
                                        return (
                                            <div key={item} className="events-page-past-item">
                                                <span>{FakeData.months[item - 1]}</span>
                                                <div className="events-page-past-items">
                                                    {
                                                        this.getMonthEvents(item, events.filter((_item) => { return _item.isPast })).map((__item, __i) => {
                                                            return (
                                                                <UpcomingEventItem style={{ margin: "10px" }} event={__item} key={__i} isPast={true} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <EmptyState style={{ background: "#fff" }} isShown={(events.filter((item) => { return item.isPast }).length === 0) ? true : false} text="No events were found!" icon="event" />
                        </FullPanel>
                    </div>
                }

                {activeTab === "find" && !isLoading &&
                    <div className="events-page-mid">
                        <FullPanel
                            title={this.state.search.length === 0 ? "Nothing found!" : "Events found (" + FakeData.shortDigit(this.state.search.length).data + ")"}
                            showFoot={false}
                            foot={"See All"}
                            bodyCss={{ padding: "0px" }}
                            onFootClick={() => {

                            }}>

                            <div className="events-page-past-list">
                                {
                                    this.getEventMonths(this.state.search).map((item, i) => {
                                        return (
                                            <div key={i} className="events-page-past-item">
                                                <span>{FakeData.months[item - 1]}</span>
                                                <div className="events-page-past-items" style={{ padding: "0.5vw 0px" }}>
                                                    {
                                                        this.state.search.filter((_item) => { return _item.month === item || _item.e_month === item; }).map((event, e) => {
                                                            return (
                                                                <div key={"event_" + e}>
                                                                    <EventSliderItem withLabel={false} label={""} style={{ width: "38vw", height: "26vw", margin: "0px 0.5vw 0.5vw 0.5vw" }} event={event} />
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <EmptyState style={{ background: "#fff" }} isShown={(this.state.search.length === 0) ? true : false} text="No events were found!" icon="event" />
                        </FullPanel>
                    </div>
                }

                {activeTab !== "calendar" &&
                    <div className="events-page-right">
                        <FullPanel
                            title={"Find Events"}
                            showFoot={false}
                            foot={""}
                            bodyCss={{ padding: "0px" }}
                            onFootClick={() => {

                            }}>
                            <div className="events-page-right-filter">
                                {
                                    this.getFixedFilters().map((item, i) => {
                                        return (
                                            <div key={i} onClick={() => {
                                                if (item.text === "Choose Date") {
                                                    return;
                                                }
                                                this.goTo(item.text === "This Week" ? "this week" : item.text)
                                            }} ref="holder" className="events-page-right-filter-item" style={{ color: FakeData.getLuminance(item.color) }} tabIndex={0}>
                                                <i className="material-icons">{item.icon}</i>
                                                <span>{item.text}</span>
                                                <div style={{ background: item.color, color: FakeData.getLuminance(item.color) }}></div>
                                                {item.text === "Choose Date" &&
                                                    <EvtFilterCal parent={this.refs.holder} />
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </FullPanel>

                        {birthdays.upcoming.length > 0 &&
                            <FullPanel
                                title={"Upcoming Birthdays"}
                                showFoot={false}
                                foot={""}
                                thisCss={{ marginTop: "1vw" }}
                                onFootClick={() => {

                                }}>
                                {
                                    birthdays.upcoming.map((item, i) => {
                                        return (
                                            <div className="events-page-right-up-evt-item" key={i}>
                                                <img src={item.user.image} />
                                                <div className="events-page-right-up-evt-item-info">
                                                    <a>{item.user.name}</a>
                                                    <span>{item.birthday.when}</span>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </FullPanel>
                        }
                    </div>
                }

                {isAddingEvent &&
                    <CreateNormalEvent toId={FakeData.getData("yoo").id} toType={"F"} isOpen={isAddingEvent} onClose={(data) => {
                        this.setState({ isAddingEvent: false });
                    }} />
                }
            </div>
        );
    }
}

class BirthdayWishForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            birthday: this.props.birthday,
            text: "",
            isPosting: false,
            error: false,
            hasPosted: this.props.birthday.posted
        }
    }

    post = () => {
        const state = this.state;
        const { birthday, userId, userType } = this.props;
        if (state.text === "") {
            this.setState({ error: true });
            return
        }

        this.setState({ isPosting: true });

        const _that = this
        const newPost = {
            user: { id: FakeData.getData("yoo"), type: "F" },
            userTo: birthday.user,
            type: 1,
            postType: "birthday",
            sport: null,
            isEvent: false,
            content: state.text,
            media: [],
            timeAgo: new Date(),
            isLiked: false,
            likes: [],
            place: [],
            shares: [],
            commentType: "post",
            audience: "friends",
            tagged: [],
            audienceList: [],
            tagsLen: [],
            comments: []
        }

        this.setState((state, props) => { return { isPosting: true } });
        console.log(newPost)

        FakeData.post('/createPost.php?auth0', newPost, {
            success: ((res) => {
                _that.setState({
                    isPosting: false,
                    text: "",
                    hasPosted: true
                })
            }),
            error: ((err) => {

            })
        }, true, "Post was added to Timeline!", ((data) => {

        }))
    }

    render = () => {
        const state = this.state;
        const { birthday, userId, userType } = this.props;
        return (
            <div className="birth-wish-form">
                <img src={birthday.user.image} />
                <div className="birth-wish-form-fld">
                    <div>
                        <a>{birthday.user.name}</a>
                        <span>{birthday.birthday.turning} years old</span>
                    </div>
                    {!state.hasPosted && <textarea value={state.text} className={state.error ? "error" : ""} placeholder={"Say something to " + birthday.user.name.split(" ")[0]} onChange={(e) => { this.setState({ text: e.target.value, error: false }) }} />}
                    {!state.hasPosted && <button onClick={this.post.bind(this)} disabled={state.isPosting}>Post</button>}
                    {state.hasPosted && <span>Your posted on {birthday.user.name.split(" ")[0]}'s timeline</span>}
                </div>
            </div>
        )
    }
}

const FullPanel = (props) => {
    const { showFoot, children, title, foot, onFootClick, thisCss, titleCss, bodyCss, footCss } = props
    return (
        <div className="events-full-panel" style={{ ...thisCss }}>
            <div className="events-full-panel-head" style={{ ...titleCss }}>{props.title}</div>
            <div className="events-full-panel-body" style={{ ...bodyCss }}>{children}</div>
            {showFoot && <div className="events-full-panel-foot" onClick={onFootClick} style={{ ...footCss }}>{foot}</div>}
        </div>
    )
}

class UpcomingEventItem extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    getEventUsers = (txt) => {
        const { event } = this.props;
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.status === txt;
        })

        return list;
    }

    inInvites = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].user.id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    getFriends = () => {
        const { event } = this.props
        const list = FakeData.listify(FakeData.getData("yoo").friends).filter((item) => {
            return !this.inInvites(item, event.invites);
        })

        return list;
    }

    interested = () => {
        const { event } = this.props;
        const _that = this;
        const dataTo = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: event.created,
            eventId: event.id,
            isInterested: true
        }

        FakeData.post("/addToEvent.php?auth0", dataTo, {
            success(res) {
                FakeData.alert("Done!");
            },
            error(err) {

            }
        }, true, "", (t) => { })
    }

    changeAttendStatus = (txt) => {
        const { event } = this.props;
        const dataTo = {
            id: event.id,
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: event.created,
            status: txt
        }

        const _that = this;

        FakeData.post("/acceptEventInvite.php?auth0", dataTo, {
            success(r) {
                FakeData.alert("Done!");
                _that.refs.root.focus()
            },
            error(r) {
                FakeData.alert("Couldn't reached server!");
                _that.refs.root.focus()
            }
        }, true, "", () => { })
    }

    getYou = () => {
        const id = FakeData.getData("yoo").id;
        const { event } = this.props;
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.user.id === id;
        })

        if (list.length === 0) {
            return false;
        }

        //console.log(list)

        return list[0];
    }

    render = () => {
        const { event, style, isPast } = this.props;
        const date = event.fullTimestamp.split(",");
        const sDate = date[1] ? date[1].split(" ") : ["", event.day, FakeData.months[event.month].substr(0, 3)];
        //console.log(sDate)
        return (
            <Link style={{ ...style }} to={{ pathname: "/event/" + event.id, search: "?sInit=about" }} className="gl-upcoming-event-item" ref={"root"}>
                <div className="gl-upcoming-event-item-date">
                    <span>{sDate[2] + " " + sDate[1]}</span>
                    <span>{date[0]}</span>
                </div>
                <div className="gl-upcoming-event-item-body">
                    <span className="gl-upcoming-event-item-body-title">{event.name}</span>
                    <span className="gl-upcoming-event-item-body-time-venue">
                        {event.startTime} - {event.place}
                    </span>
                    {this.getEventUsers("yes").length > 1 &&
                        <div className="gl-upcoming-event-item-body-going">
                            <span>{FakeData.shortDigit(this.getEventUsers("yes").length).text} going</span>
                        </div>
                    }

                    {this.getEventUsers("yes").length <= 1 &&
                        <div className="gl-upcoming-event-item-body-going">
                            <span>Created by {event.created.name}</span>
                        </div>
                    }
                    {!isPast &&
                        <div className="gl-upcoming-event-item-body-actions">
                            {(!this.inInvites(FakeData.getData("yoo"), event.invites) && !event.isAdmin) &&
                                <div className="gl-upcoming-event-item-body-action" onClick={this.interested.bind(this)}>
                                    <i className="material-icons">add</i>
                                    <span>Interested</span>
                                </div>
                            }
                            {(this.inInvites(FakeData.getData("yoo"), event.invites) && this.getYou()) &&
                                <div className="gl-upcoming-event-item-body-action drop-box-gl" ref={"status"} tabIndex={0}>
                                    <i className="material-icons">settings</i>
                                    <span>{this.getYou()['status'] === "yes" ? "Going" : this.getYou()['status'] === "maybe" ? "Maybe" : "Not going"}</span>
                                    <div className="drop-box-gl-content" >
                                        <span className={this.getYou()['status'] === "yes" ? "active" : ""} onClick={() => this.changeAttendStatus("yes")}>Going</span>
                                        <span className={this.getYou()['status'] === "maybe" ? "active" : ""} onClick={() => this.changeAttendStatus("maybe")}>Maybe</span>
                                        <span className={this.getYou()['status'] === "no" ? "active" : ""} onClick={() => this.changeAttendStatus("no")}>Not Going</span>
                                    </div>
                                </div>
                            }
                            {event.type !== "Private" &&
                                <div className="gl-upcoming-event-item-body-action">
                                    <i className="material-icons">share</i>
                                    <span>Share</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            </Link>
        )
    }
}

class EventSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            prev: 0,
            next: 1,
            offset: 0,

        }
    }

    componentDidMount() {
        //var rect = this.refs.root.getBoundingClientRect();
        //console.log(rect)
    }

    next = () => {
        const { offset } = this.state;
        const { events } = this.props;
        const maxOffset = FakeData.listify(events).length * -38;
        this.setState({ offset: (offset - 39) <= maxOffset ? offset : (offset - 39) });
    }

    prev = () => {
        const { offset } = this.state;
        const { events } = this.props;
        const maxOffset = FakeData.listify(events).length * 38;
        this.setState({ offset: (offset + 39) >= 0.5 ? 0 : (offset + 39) });
    }

    render = () => {
        const { offset, prev, next, index } = this.state;
        const { events, style } = this.props;
        const maxOffset = FakeData.listify(events).length * -38;
        if (events.length === 0) {
            return (
                <EmptyState style={{ background: "#fff", width: "39vw", height: "39vw", ...style }} isShown={(events.length === 0) ? true : false} text="No events were found!" icon="event" />
            )
        }
        return (
            <div className="gl-event-slider" ref={"root"} style={{ width: "39vw", position: "relative", padding: "10px 0.5vw", ...style }}>
                {offset < 0 &&
                    <div className="gl-event-slider-prev" onClick={this.prev.bind(this)}>
                        <i className="material-icons" style={{ fontSize: "inherit", color: "inherit" }}>chevron_left</i>
                    </div>
                }
                <div className="gl-event-slider-list">
                    {
                        FakeData.listify(events).map((item, i) => {
                            return (
                                <EventSliderItem withLabel={true} label={(i + 1) + "/" + FakeData.listify(events).length} style={i === 0 ? { width: "38vw", height: "26vw", margin: "0px 0.5vw", marginLeft: offset + "vw" } : { width: "38vw", height: "26vw", margin: "0px 0.5vw" }} key={i} event={item} />
                            )
                        })
                    }
                </div>
                {((offset - 38) > maxOffset && FakeData.listify(events).length > 1) &&
                    <div className="gl-event-slider-next" onClick={this.next.bind(this)}>
                        <i className="material-icons" style={{ fontSize: "inherit", color: "inherit" }}>chevron_right</i>
                    </div>
                }
            </div>
        )
    }
}

class EventSliderItem extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    getEventUsers = (txt) => {
        const { event } = this.props;
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.status === txt;
        })

        return list;
    }

    inInvites = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].user.id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    getFriends = () => {
        const { event } = this.props
        const list = FakeData.listify(FakeData.getData("yoo").friends).filter((item) => {
            return !this.inInvites(item, event.invites);
        })

        return list;
    }

    interested = () => {
        const { event } = this.props;
        const _that = this;
        const dataTo = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: event.created,
            eventId: event.id,
            isInterested: true
        }

        FakeData.post("/addToEvent.php?auth0", dataTo, {
            success(res) {
                FakeData.alert("Done!");
            },
            error(err) {

            }
        }, true, "", (t) => { })
    }

    changeAttendStatus = (txt) => {
        const { event } = this.props;
        const dataTo = {
            id: event.id,
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: event.created,
            status: txt
        }

        const _that = this;

        FakeData.post("/acceptEventInvite.php?auth0", dataTo, {
            success(r) {
                FakeData.alert("Done!");
                _that.refs.root.focus()
            },
            error(r) {
                FakeData.alert("Couldn't reached server!");
                _that.refs.root.focus()
            }
        }, true, "", () => { })
    }

    getYou = () => {
        const id = FakeData.getData("yoo").id;
        const { event } = this.props;
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.user.id === id;
        })

        if (list.length === 0) {
            return false;
        }

        //console.log(list)

        return list[0];
    }

    render = () => {
        const { } = this.state;
        const { event, style, withLabel, label } = this.props;
        const date = event.fullTimestamp ? event.fullTimestamp.split(",") : [];
        const sDate = date[1] ? date[1].split(" ") : ["", event.day, FakeData.months[event.month] ? FakeData.months[event.month].substr(0, 3) : ""];
        return (
            <Link to={{ pathname: "/event/" + event.id, search: "?sInit=about" }} className="gl-event-slider-item" style={{ ...style }}>
                <img src={event.file.url} />
                <div className="gl-event-slider-item-body">
                    <div className="gl-event-slider-item-body-date">
                        <span>{sDate[2]}</span>
                        <span>{sDate[1]}</span>
                    </div>
                    <div className="gl-event-slider-item-body-ctx">
                        <span className="gl-event-slider-item-body-ctx-title">{event.name}</span>
                        <span className="gl-event-slider-item-body-ctx-venue">{event.startTime} - {event.place}</span>
                        {this.getEventUsers("yes").length > 1 && <span className="gl-event-slider-item-body-ctx-going">{FakeData.shortDigit(this.getEventUsers("yes").length).text} people are going to this event</span>}
                        {this.getEventUsers("yes").length <= 1 && <span className="gl-event-slider-item-body-ctx-going">Created by {event.created.name}</span>}
                    </div>
                </div>
                <div className="gl-upcoming-event-item-body-actions" style={{ padding: "0px 10px 10px 10px", height: "auto" }}>
                    {(!this.inInvites(FakeData.getData("yoo"), event.invites) && !event.isAdmin) &&
                        <div className="gl-upcoming-event-item-body-action" onClick={this.interested.bind(this)}>
                            <i className="material-icons">add</i>
                            <span>Interested</span>
                        </div>
                    }
                    {(this.inInvites(FakeData.getData("yoo"), event.invites) && this.getYou()) &&
                        <div className="gl-upcoming-event-item-body-action drop-box-gl" ref={"status"} tabIndex={0}>
                            <i className="material-icons">settings</i>
                            <span>{this.getYou()['status'] === "yes" ? "Going" : this.getYou()['status'] === "maybe" ? "Maybe" : "Not going"}</span>
                            <div className="drop-box-gl-content" >
                                <span className={this.getYou()['status'] === "yes" ? "active" : ""} onClick={() => this.changeAttendStatus("yes")}>Going</span>
                                <span className={this.getYou()['status'] === "maybe" ? "active" : ""} onClick={() => this.changeAttendStatus("maybe")}>Maybe</span>
                                <span className={this.getYou()['status'] === "no" ? "active" : ""} onClick={() => this.changeAttendStatus("no")}>Not Going</span>
                            </div>
                        </div>
                    }
                    {event.type !== "Private" &&
                        <div className="gl-upcoming-event-item-body-action">
                            <i className="material-icons">share</i>
                            <span>Share</span>
                        </div>
                    }
                </div>
                {withLabel && <span style={{ position: this.absolute(), bottom: 0, right: 0, margin: "15px", color: "#000", fontWeight: 600 }}>{label}</span>}
            </Link>
        )
    }

    absolute() {
        return "absolute";
    }
}

export class EvtFilterCal extends Component {
    constructor(props) {
        super(props);
        this.date = new Date();
        this.date.setMinutes(this.date.getMinutes() - this.date.getTimezoneOffset());
        this.state = {
            firstMonth: {
                date: this.date.getDate(),
                year: this.date.getFullYear(),
                month: FakeData.months[this.date.getMonth()],
                index: this.date.getMonth(),
                lastDay: this.getLastDay(this.date.getFullYear(), this.date.getMonth())
            },
            secondMonth: {
                date: this.date.getDate(),
                year: this.date.getMonth() === 11 ? this.date.getFullYear() + 1 : this.date.getFullYear(),
                month: FakeData.months[this.date.getMonth() === 11 ? 0 : this.date.getMonth() + 1],
                index: this.date.getMonth() === 11 ? 0 : this.date.getMonth() + 1,
                lastDay: this.getLastDay(this.date.getMonth() === 11 ? this.date.getFullYear() + 1 : this.date.getFullYear(), this.date.getMonth() === 11 ? 0 : this.date.getMonth() + 1)
            },
            firstDates: this.genDays(this.date.getFullYear(), this.date.getMonth() + 1),
            secondDates: this.genDays(this.date.getMonth() === 11 ? this.date.getFullYear() + 1 : this.date.getFullYear(), this.date.getMonth() === 11 ? 1 : this.date.getMonth() + 2),
            start: null,
            end: null,
            preEnd: null
        }
    }

    getLastDay = (year, month) => {
        //var year = this.date.getFullYear()
        var date = new Date(year, this.date.getMonth() + 1, 0)
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
        return date.getDate()
    }

    prev = (int) => {
        const { firstMonth, secondMonth, firstDates, secondDates } = this.state;
        if (firstMonth.index === 0) {
            var year = parseInt(firstMonth.year) - 1
            this.setState({
                secondMonth: firstMonth,
                firstMonth: {
                    date: this.date.getDate(),
                    year: year,
                    month: FakeData.months[11],
                    index: 11,
                    lastDay: this.getLastDay(year, 12)
                },
                secondDates: firstDates,
                firstDates: this.genDays(year, 13)
            })
        } else {
            var year = firstMonth.year
            this.setState({
                secondMonth: {
                    date: this.date.getDate(),
                    year: int === 11 ? (year + 1) : year,
                    month: FakeData.months[int === 11 ? 0 : (int + 1)],
                    index: int === 11 ? 0 : (int + 1),
                    lastDay: this.getLastDay(int === 11 ? (year + 1) : year, int === 11 ? 0 : (int + 1))
                },
                firstMonth: {
                    date: this.date.getDate(),
                    year: year,
                    month: FakeData.months[int],
                    index: int,
                    lastDay: this.getLastDay(year, int)
                },
                secondDates: this.genDays(int === 11 ? (year + 1) : year, int === 11 ? 1 : (int + 2)),
                firstDates: this.genDays(year, int + 1)
            })
        }
    }

    next = (int) => {
        const { firstMonth, secondMonth, firstDates, secondDates } = this.state;
        if (secondMonth.index === 11) {
            var year = parseInt(secondMonth.year) + 1
            this.setState({
                firstMonth: secondMonth,
                secondMonth: {
                    date: this.date.getDate(),
                    year: year,
                    month: FakeData.months[0],
                    index: 0,
                    lastDay: this.getLastDay(year, 1)
                },
                firstDates: secondDates,
                secondDates: this.genDays(year, 2)
            })
        } else {
            var year = secondMonth.year
            this.setState({
                firstMonth: secondMonth,
                secondMonth: {
                    date: this.date.getDate(),
                    year: year,
                    month: FakeData.months[int],
                    index: int,
                    lastDay: this.getLastDay(year, int)
                },
                firstDates: secondDates,
                secondDates: this.genDays(year, int + 1)
            })
        }
    }

    genDays = (year, month, isUpdate) => {
        var date = new Date(year, month, 0)
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
        var firstDay = new Date(year, month - 1, 1)
        firstDay.setMinutes(firstDay.getMinutes() - firstDay.getTimezoneOffset())
        //var endDay = new Date(year, month + 1, 1)
        //endDay.setMinutes(endDay.getMinutes() - endDay.getTimezoneOffset())
        var startDay = firstDay.getDay()
        //var _endDay = endDay.getDay();
        //console.log(_endDay)
        const arr = []
        for (let i = 0; i < date.getDate() + startDay; i++) {
            if (i < startDay) {
                arr.push({
                    id: null,
                    value: i,
                    year: year,
                    month: month
                })
            } else {
                const bool = Boolean(isUpdate)
                const events = []
                arr.push({
                    id: i,
                    value: i - startDay,
                    year: year,
                    month: month
                })
            }

        }



        return arr
    }

    onDateSelect = (date) => {
        const { firstMonth, secondMonth, firstDates, secondDates, start, end } = this.state;
        const _date = new Date(date);
        if (start === null) {
            this.setState((state, props) => { return { start: date, end: null } });
        } else {
            const _d = new Date(start);
            this.setState({
                start: _date.getTime() > _d.getTime() ? start : date,
                end: _date.getTime() < _d.getTime() ? start : date
            });
        }
    }

    clear = () => {
        const { onDatePicked, parent } = this.props;
        if (parent) {
            parent.focus()
        }
        this.setState((state, props) => { return { start: null, end: null } });
    }

    render = () => {
        const { firstMonth, secondMonth, firstDates, secondDates, start, end } = this.state;
        const _s = start !== null ? new Date(start) : null;
        const _e = end !== null ? new Date(end) : null;
        const { onDatePicked, parent } = this.props;
        return (
            <div className="evt-filters-cal">
                <EvtFilterCalItem onClick={this.prev.bind(this)} start={start === null ? false : start} end={end === null ? false : end} onDateSelect={this.onDateSelect.bind(this)} month={firstMonth} dates={firstDates} monthIndex={firstMonth.index} index={1} />
                <EvtFilterCalItem onClick={this.next.bind(this)} start={start === null ? false : start} end={end === null ? false : end} onDateSelect={this.onDateSelect.bind(this)} month={secondMonth} dates={secondDates} monthIndex={firstMonth.index} index={2} />
                <div className="evt-filters-cal-actions">
                    <span>{_s !== null ? _s.toLocaleDateString() : null}{_e !== null ? " - " + _e.toLocaleDateString() : null}</span>
                    <div className="bt" onClick={this.clear.bind(this)}>Clear</div>
                    {start === null && end === null && <div className="bt link">Done</div>}
                    {start !== null && end !== null &&
                        <div className="bt link" onClick={(e) => {
                            if(onDatePicked){
                                onDatePicked(start,end)
                                if(parent){
                                    parent.focus()
                                }
                                
                                return;
                            } else{
                                window.location = "/events?sInit=find&start=" + start + "&end=" + end;
                            }
                        }}>Done</div>
                    }
                </div>
            </div>
        )
    }
}

class EvtFilterCalItem extends Component {
    state = {

    }

    getDummy = (_num) => {
        const list = [];
        for (var index = 0; index < _num; index++) {
            list.push({ text: index })
        }

        return list;
    }

    render = () => {
        const { index, month, dates, onDateSelect, start, end, onClick } = this.props;
        return (
            <div className="evt-filter-cal">
                <div className="evt-filter-cal-head">
                    {index === 1 && <i onClick={() => onClick(month.index - 1)} className="material-icons" style={{ fontSize: "inherit", color: "inherit" }}>chevron_left</i>}
                    <span>{month.month}, {month.year}</span>
                    {index === 2 && <i onClick={() => onClick(month.index + 1)} className="material-icons" style={{ fontSize: "inherit", color: "inherit" }}>chevron_right</i>}
                </div>
                <div className="evt-filter-cal-days">
                    {
                        FakeData.days.map((item, i) => {
                            return (
                                <span key={i}>
                                    {item}
                                </span>
                            )
                        })
                    }
                </div>
                <div className="evt-filter-cal-dates">
                    {
                        dates.map((item, i) => {
                            const _date = (month.index + 1) + " " + (item.value + 1) + " " + month.year;
                            const _d = new Date(_date);
                            const _s = new Date(start);
                            const _e = new Date(end);
                            if (item.id === null) {
                                return (
                                    <span key={i}></span>
                                )
                            }
                            return (
                                <span onMouseEnter={() => {
                                    const date = (month.index + 1) + " " + (item.value + 1) + " " + month.year;
                                }} className={(!start && !end) ? "" : (start === _date || end === _date) ? "point" : (_d.getTime() > _s.getTime() && _d.getTime() < _e.getTime()) ? "point mini" : ""} key={i} onClick={() => {
                                    if (item.id === null) {
                                        return;
                                    }

                                    const date = (month.index + 1) + " " + (item.value + 1) + " " + month.year;
                                    onDateSelect(date)
                                }}>
                                    {item.id === null ? null : (item.value + 1)}
                                </span>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Events.jsx